<div class="dropdown-container" [class.animating]="isAnimating" [class.show-hint-text]="hintText">
  <div class="mb-1 d-flex gap-1"  >
    <span class="label">{{ label }}</span>
    <span class="required" *ngIf="required"> *</span>
  </div>
  <div
    tabindex="0"
    #dropdownElement
    [ngClass]="['dropdown', disabled ? 'disabled' : '', error ? 'error' : '']"
    (click)="togglePanel()"
    (keydown)="onKeyDown($event)"
  >
    <ng-content select="ds-dropdown-trigger"></ng-content>
    <span
      #selectedOptionContainer
      *ngIf="!trigger && selectedOptions.length > 0"
      class="dropdown-value selected-option-content"
    ></span>
    <span
      *ngIf="!trigger && selectedOptions.length === 0"
      class="dropdown-value"
      [class.dropdown-placeholder]="isPlaceholder"
    >
      {{ displayValue }}
    </span>

    <ds-icon icon="dropdown-arrow" class="icon"></ds-icon>
  </div>

  <div class="mt-1 d-flex" *ngIf="hintText">
    <span  class="hint-text" [class.error]="error" [class.disabled]="disabled">{{ hintText }}</span>
  </div>

  <ng-template #optionListContent>
    <div class="option-list dropdown-list" [@fadeInOut]="animationState">
      <div class="option-list-content">
        <ng-content></ng-content>
        <ds-option *ngIf="!hasOptions" [default]="true" value="">{{ emptyOptionsText }}</ds-option>
      </div>
    </div>
  </ng-template>
</div>
